import React, { useRef } from "react";
import { points, home } from "../../../constants/points";
import { useDrawer, useTheme } from "../../../common/hooks";
import NavbarElement from "./NavbarElement";
import { useProgress } from "@react-three/drei";
import classNames from "classnames";
import "./navbar.css";

export default function Navbar() {
  const { theme } = useTheme();
  const { progress } = useProgress();
  const { isOpen } = useDrawer();
  const ref = useRef();

  return (
    <div
      className={classNames("navbar-vertical-container", {
        "hidden-navbar": isOpen || progress !== 100,
      })}
      style={{ backgroundColor: theme.menubg }}
      ref={ref}
    >
      <NavbarElement section={home} />

      {points.map((point) => (
        <NavbarElement key={point.name} section={point} />
      ))}
    </div>
  );
}
